// extracted by mini-css-extract-plugin
module.exports = {"salesSummary":"salesSummary___M5mb1","summaryCard":"summaryCard___1hb_0","summaryTable":"summaryTable___lvYyN","skeletonLoading":"skeletonLoading___3j3EC"};